import React from 'react'
// libs
import styled, { RuleSet } from 'styled-components'
// components
import { Menu } from 'components/UI'
import { MenuItem as MaterialMenuItem } from '@mui/material'
// themes
import { colors } from 'themes/index'
// icons
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
// utils
import { size } from 'polished'

export const DotsIcon = styled(DotsIconOrigin)<{ preset: 'light' | 'dark'; styles?: RuleSet<any> }>`
  && {
    cursor: pointer;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 99999;
    ${size('25px')};

    g {
      fill: ${({ preset }) => (preset === 'light' ? colors.white100 : colors.black)};
    }

    ${({ styles }) => styles}
  }
`

const MenuItem = styled(MaterialMenuItem)`
  && {
    background-color: transparent !important;
    color: ${colors.blue500};
    font-size: 16px;
    min-height: unset;
    min-width: 100px;
    padding: 0;

    &:hover {
      background-color: ${colors.gray180} !important;
    }

    > span {
      display: flex;
      gap: 8px;
      padding: 4px 12px;
      width: 100%;
    }
  }
`

interface Props {
  preset?: 'light' | 'dark'
  styles?: RuleSet<any>
  children?: React.ReactNode
}

const DetailsButton: React.FC<Props> = ({ preset = 'dark', styles, children }) => {
  return (
    <Menu trigger={<DotsIcon styles={styles} preset={preset} />} MenuItem={MenuItem}>
      {children}
    </Menu>
  )
}

export default DetailsButton
